import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    zIndex: 1000,
    background: theme.palette.background.paper,
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    padding: '16px 32px',
    width: '100%',
    position: 'sticky',
    bottom: 0,
    boxShadow: theme.shadows[5]
  },
  button: {
    backgroundColor: '#159B78',
    color: 'white'
  },
  buttonDiscart: {
    outline: '1px solid #be1224 !important',
    color: '#be1224'
  }
}));
